import axios from 'axios'
import { VALIDATE_INFORMATION_PROVIDER } from 'constants/endpoints'

const axiosClient = axios.create()

export const validateInformationProvider = async payload => {
   const {
      legalNature: personType,
      email,
      documentNumber,
      documentType
   } = payload
   const body = { personType, documentType, documentNumber, email }
   const endpoint = `${process.env.REACT_APP_PROVIDER_INSCRIPTION_API}${VALIDATE_INFORMATION_PROVIDER}`
   const { data = {} } = await axiosClient.post(endpoint, body)
   return { data }
}
